import {
  Avatar,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import { FileArgs } from "interfaces/serviciosGenerales/serviciosGeneralesInterface";
import { FaFilePdf } from "react-icons/fa";
import { FiEye } from "react-icons/fi";
import { MdDelete } from "react-icons/md";

interface FilePropsInterface {
  file: FileArgs;
  disabled?: boolean;
  startDeleteFile: (file: FileArgs) => void;
  startGetFile: (body: any) => void;
  openModalVisor?: (status: boolean) => void;
}

export const ListFilesOptions = ({
  file,
  disabled = false,
  startDeleteFile,
  startGetFile,
}: FilePropsInterface) => {
  const handleChangeOpenModal = () => {
    startGetFile({ path: file.path });
  };

  return (
    <ListItem
      key={file.idFirmaDocumento}
      secondaryAction={
        <>
          <IconButton
            edge="start"
            aria-label="view"
            className="px-4"
            onClick={() => handleChangeOpenModal()}
          >
            <FiEye />
          </IconButton>
          <IconButton
            edge="end"
            aria-label="delete"
            className="px-4"
            onClick={() => startDeleteFile(file)}
            disabled={disabled}
          >
            <MdDelete />
          </IconButton>
        </>
      }
    >
      <ListItemAvatar>
        <Avatar>
          <FaFilePdf />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        disableTypography
        style={{
          maxWidth: "55%",
          minWidth: "55%",
          marginRight: "5%",
          // wordBreak: "break-word",
          // overflowWrap: "break-word",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        primary={file.fileName || file.filename}
      />
      <ListItemText
        disableTypography
        style={{
          maxWidth: "40%",
          minWidth: "40%",
        }}
        primaryTypographyProps={{ variant: "body2", textAlign: "right" }}
        primary={`${file.size} MB`}
      />
    </ListItem>
  );
};
